module.exports = __webpack_public_path__ + "media/images/partner/supporter/wbs-b14fef61bf3148fab0cbaa6b681a5fe3.png";